import { SectionKey } from '../../../../types';
import { FormConfigOptions } from '../types';
import { FormSchemaConfig } from '../types/form/schema.types';
import { GLOBAL_FORM_CONFIG } from './formConfig';

export const EMPTY_SCHEMA: FormSchemaConfig = { sections: [] };
export const INITIAL_SCHEMAS: Record<SectionKey, FormSchemaConfig> = {
  request_reassign: EMPTY_SCHEMA,
  rejected_form: EMPTY_SCHEMA,
  payment_details: EMPTY_SCHEMA,
  resp_lawyer: EMPTY_SCHEMA,
  first_partner: EMPTY_SCHEMA,
  second_partner: EMPTY_SCHEMA,
  second_partner_above_25k: EMPTY_SCHEMA,
  second_partner_below_25k: EMPTY_SCHEMA,
  payment_hold_review: EMPTY_SCHEMA,
  payment_confirmation: EMPTY_SCHEMA,
  document_saving: EMPTY_SCHEMA,
  dubai_payment_from_office_account_payment_details: EMPTY_SCHEMA,
  dubai_payment_from_office_account_approver: EMPTY_SCHEMA,
  dubai_payment_from_office_account_payment_confirmation: EMPTY_SCHEMA,
  dubai_transfer_requisition_payment_details: EMPTY_SCHEMA,
  dubai_transfer_requisition_first_partner: EMPTY_SCHEMA,
  dubai_transfer_requisition_second_partner: EMPTY_SCHEMA,
  dubai_transfer_requisition_payment_confirmation: EMPTY_SCHEMA,
  overtime_approval_request_details: EMPTY_SCHEMA,
  overtime_approval_line_manager: EMPTY_SCHEMA,
  overtime_approval_finance_confirmation: EMPTY_SCHEMA,
};

export const DEFAULT_ERROR_MESSAGES = {
  required: 'This field is required',
  pattern: 'Invalid format',
  min: 'Value is too small',
  max: 'Value is too large',
  custom: 'Invalid value',
};

export const DEFAULT_FORMATTERS = {
  input: (value: any) => value,
  output: (value: any) => value,
  display: (value: any) => String(value ?? ''),
};

export const DEFAULT_VALIDATION_MESSAGES = {
  required: 'This field is required',
  min: 'Value must be at least {min}',
  max: 'Value must be at most {max}',
  pattern: 'Invalid format',
} as const;

export const DEFAULT_NUMBER_FORMAT: Intl.NumberFormatOptions = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
} as const;

export const DEFAULT_CONFIG: FormConfigOptions = GLOBAL_FORM_CONFIG;
